import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";

const Table = ({ className, items = [], onStudentSelect }) => {
  const [activeId, setActiveId] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  const handleStudentClick = (id) => {
    if (onStudentSelect) {
      onStudentSelect(id);
    }
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={styles.row}>
          <div className={styles.col}>
            
          </div>
          <div className={styles.col}>Nom Prénom</div>
          <div className={styles.col}>Email</div>
          <div className={styles.col}>Date d'inscription</div>
          <div className={styles.col}>Entreprise</div>
          <div className={styles.col}>Etat du dossier</div>
          <div className={styles.col}>Status</div>
        </div>
        {items.length > 0 ? (
          items.map((x, index) => (
            <Row
              item={x}
              key={index}
              activeId={activeId}
              setActiveId={setActiveId}
              value={selectedFilters.includes(x.id)}
              onChange={() => handleChange(x.id)}
              onClick={() => handleStudentClick(x.id)}
            />
          ))
        ) : (
          <div className={styles.noData}>Aucune donnée disponible</div>
        )}
      </div>
    </div>
  );
};

export default Table;
